'use client';

export { default } from './CssBaseline';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CssBaseline/index.js
// module id = 835
// module chunks = 22